import React from 'react';

import DashboardHeader from '../DashboardHeader/DashboardHeader.js';

import './Beneficiaries.css';

const Beneficiaries = (props) => {
  return (
    <React.Fragment>
      <DashboardHeader
        header="Beneficiaries"
        user={props.user}
      />
      <div className="Dashboard-content Beneficiaries">
        <p>Coming soon.</p>
      </div>
    </React.Fragment>
  );
}

export default Beneficiaries;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/Beneficiaries/Beneficiaries.js